export const setLike = () => {
  const likeButton = document.querySelector('.article-recent--like--btn');
  likeButton.addEventListener('click', async (e) => {
    e.preventDefault();
    const breedId = document.querySelector('.breed-detail__info').getAttribute('data-breed-id');
    const urlLike = `/api/breed/${breedId}/like/`;
    const res = await fetch(urlLike, {
      method: 'PUT',
    });

    const data = await res.json();

    if (!!data) {
      document.querySelector('.likes-count').textContent = data;
      e.target.classList.add('breed-btn__disabled');
    }
  });
};
